import { render, staticRenderFns } from "./SyncOverviewTab.vue?vue&type=template&id=2c39e0ba&scoped=true";
import script from "./SyncOverviewTab.vue?vue&type=script&lang=js";
export * from "./SyncOverviewTab.vue?vue&type=script&lang=js";
import style0 from "./SyncOverviewTab.vue?vue&type=style&index=0&id=2c39e0ba&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "2c39e0ba", null);
export default component.exports;